
import React from "react";


const GenerateLoi = () =>{
    return(
        <div className="row">
            <div className="col-lg-3">
                <div className="card">
                    <div className="card-block">
                        <h5 className="mb-0">Build Your Template</h5>
                        <p className="f-12">Include active salary components</p>
                        <div className="accordion" id="accordionExample2">
                            <div class="accordion-item">
                                <h2 className="accordion-header">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsedemoOne" aria-expanded="true" aria-controls="collapsedemoOne">
                                        Earnings
                                    </button>
                                </h2>
                                <div id="collapsedemoOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample2">
                                    <div class="accordion-body">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="checkbox_1" />
                                            <label class="form-check-label f-14" for="checkbox_1">
                                                Fixed CTC
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="checkbox_2" checked />
                                            <label class="form-check-label f-14" for="checkbox_2">
                                                Basic Salary
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="checkbox_3" checked />
                                            <label class="form-check-label f-14" for="checkbox_3">
                                                HRA
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="checkbox_4" checked />
                                            <label class="form-check-label f-14" for="checkbox_4">
                                                MI
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="checkbox_5" checked />
                                            <label class="form-check-label f-14" for="checkbox_5">
                                                Other Allowance
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsedemoTwo" aria-expanded="false" aria-controls="collapsedemoTwo">
                                        Other Benefits
                                    </button>
                                </h2>
                                <div id="collapsedemoTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample2">
                                    <div class="accordion-body">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="checkbox_6" checked />
                                            <label class="form-check-label f-14" for="checkbox_6">
                                                Other Allowance
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsedemoThree" aria-expanded="false" aria-controls="collapsedemoThree">
                                        Deductions
                                    </button>
                                </h2>
                                <div id="collapsedemoThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample2">
                                    <div class="accordion-body">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="checkbox_7" checked />
                                            <label class="form-check-label f-14" for="checkbox_7">
                                                Net Salary
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="checkbox_8" checked />
                                            <label class="form-check-label f-14" for="checkbox_8">
                                                Total Deduction
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-9">
                <div className="card">
                    <div className="card-block">
                        <h5 className="mb-0">Salary</h5>
                        <p>Define salary for employee</p>
                        <div className="row mt-3">
                            <div className="col-lg-4">
                                <div className="form-group">
                                    <label className="form-label">Name</label>
                                    <input type="text" className="form-control input-me" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form-group">
                                    <label className="form-label">Joining Date</label>
                                    <input type="date" className="form-control input-me" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form-group">
                                    <label className="form-label">LoI validity</label>
                                    <input type="date" className="form-control input-me" />
                                </div>
                            </div>
                            <div className="col-lg-6 mt-3">
                                <div className="form-group">
                                    <label className="form-label">Description</label>
                                    <textarea className="form-control"></textarea>
                                </div>
                            </div>
                            <div className="col-lg-6 mt-3">
                                <div className="form-group">
                                    <label className="form-label">Notes</label>
                                    <textarea className="form-control"></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive mt-4">
                            <table className="table table-bordered">
                                <tr>
                                    <th>Salary Component</th>
                                    <th>Calculation Type</th>
                                    <th>Amount Monthly</th>
                                    <th>Amount Annually</th>
                                </tr>
                                <tr>
                                    <th colSpan={4}>Earnings</th>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="text" className="form-control border" placeholder="Fixed CTC(PAY_CTC)" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control text-end" placeholder="0.00" aria-label="" aria-describedby="" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary bg-primary text-white" type="button" >Fixed</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="text" className="form-control border" placeholder="Basic Salary(BASIC)" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control text-end" placeholder="0.00" aria-label="" aria-describedby="" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary bg-primary text-white" type="button" >% PAYCTC</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="text" className="form-control border" placeholder="HRA(HRA)" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control text-end" placeholder="0.00" aria-label="" aria-describedby="" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary bg-primary text-white" type="button" >% Basic</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="text" className="form-control border" placeholder="MI(MI)" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control text-end" placeholder="0.00" aria-label="" aria-describedby="" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary bg-primary text-white" type="button" >Fixed</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="text" className="form-control border" placeholder="Other Allowance(OA)" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control text-end" placeholder="0.00" aria-label="" aria-describedby="" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary bg-primary text-white" type="button" >Fixed</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                </tr>
                                <tr>
                                    <th colSpan={4}>Other benefits</th>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="text" className="form-control border" placeholder="Total(TOTAL_EARNING_OTHER)" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control text-end" placeholder="0.00" aria-label="" aria-describedby="" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary bg-primary text-white" type="button" >Formula</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                </tr>
                                <tr>
                                    <th colSpan={4}>Deductions</th>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="text" className="form-control border" placeholder="Net Salary(NETPAYABLE)" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control text-end" placeholder="0.00" aria-label="" aria-describedby="" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary bg-primary text-white" type="button" >Formula</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="text" className="form-control border" placeholder="Total Deduction(TOTAL_DEDUCTION)" />
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control text-end" placeholder="0.00" aria-label="" aria-describedby="" />
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary bg-primary text-white" type="button" >Formula</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                    <td>
                                        <input type="text" className="form-control border text-end" placeholder="0.00" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="col-lg-12 text-end">
                            <button className="btn btn-primary">Submit</button>
                            <button className="btn btn-danger m-l-10">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GenerateLoi;